import React from "react";
import { Play, ShieldCheck } from "lucide-react";
import { dishPhoto, hasVideo, splitBadges, CommercialBadge, AttributePill, PhotoFallback } from "./shared";

// Main menu card (1A): content left, 100px photo right — compact, delivery-app style.
export default function DishCard({ d, label, onOpen }) {
  const photo = dishPhoto(d, 160);
  const video = hasVideo(d);
  const { commercial, attrs } = splitBadges(d.badges);
  const allergens = d.allergen_status === "confermato" ? (d.allergens_confirmed || []) : [];

  return (
    <button onClick={onOpen} data-testid={`dish-${d.id}`}
      className="w-full text-left rounded-2xl bg-white border border-border/80 p-3 card-shadow hover:shadow-md transition-[box-shadow,transform] active:scale-[0.99] flex gap-3 items-stretch">
      <div className="flex-1 min-w-0 flex flex-col">
        {(commercial.length > 0) && (
          <div className="flex flex-wrap gap-1 mb-1.5">{commercial.slice(0, 2).map((b) => <CommercialBadge key={b} code={b} size="xs" />)}</div>
        )}
        <h3 className="font-semibold text-[15px] text-[#0c2d34] leading-snug break-words">{d.name}</h3>
        {d.description && <p className="text-[13px] text-[#5a7177] mt-0.5 leading-snug line-clamp-2">{d.description}</p>}
        {(attrs.length > 0 || (video && photo === null)) && (
          <div className="mt-1.5 flex flex-wrap items-center gap-1">
            {attrs.map((b) => <AttributePill key={b} code={b} />)}
            {video && !photo && <span className="inline-flex items-center gap-1 rounded-full bg-[#0c2d34] text-white px-2 py-0.5 text-[10px] font-semibold"><Play className="h-2.5 w-2.5 fill-white" /> Video</span>}
          </div>
        )}
        <div className="mt-auto pt-2 flex items-end justify-between gap-2">
          {allergens.length > 0 ? (
            <p className="flex items-start gap-1 text-[11px] text-[#6b7f83] leading-tight min-w-0" data-testid={`allergens-${d.id}`}>
              <ShieldCheck className="h-3.5 w-3.5 text-emerald-600 shrink-0" />
              <span className="truncate">{allergens.map(label).join(" · ")}</span>
            </p>
          ) : <span />}
          <span className="font-bold text-[15px] text-[#123C46] whitespace-nowrap shrink-0">{d.price}</span>
        </div>
      </div>
      <div className="relative shrink-0 w-[100px] h-[100px] self-center">
        {photo ? (
          <img src={photo} alt={d.name} width="100" height="100" className="h-full w-full rounded-xl object-cover bg-muted" loading="lazy" decoding="async" />
        ) : (
          <PhotoFallback category={d._cat} className="h-full w-full rounded-xl" />
        )}
        {video && <span className="absolute bottom-1.5 right-1.5 h-7 w-7 rounded-full bg-black/60 backdrop-blur grid place-items-center shadow" data-testid={`video-indicator-${d.id}`}><Play className="h-3.5 w-3.5 text-white fill-white ml-0.5" /></span>}
      </div>
    </button>
  );
}
